import type { PublishInstagramPostParams } from '../types';

import { useMutation } from '@tanstack/react-query';

import { publishInstagramPost } from '../api';

export function usePublishInstagramPost() {
  return useMutation({
    mutationFn: ({
      pharmacyId,
      params,
    }: {
      pharmacyId: string;
      params: PublishInstagramPostParams;
    }) => publishInstagramPost(pharmacyId, params),
  });
}
